import type { FC } from 'react';
import * as st from './styles.module.scss';

interface Props {
  title: string;
  onClick: () => void;
}

export const ClientAction: FC<Props> = ({ onClick, title }) => {
  return (
    <button onClick={onClick} className={st.action}>
      {title}
    </button>
  );
};
